import React, { useState, Fragment } from 'react';
import { FaEdit, FaEye, FaTrash } from 'react-icons/fa';
import { TD } from 'styled/table';
import checkPermission from 'utils/checkPermission';
import permissions from 'utils/permissionConstants';
import Edit from './edit';
import { updateDocumentByID } from 'apis/customApiHandler';
import toast from 'react-hot-toast';

const getCurrentUserFromStorage = () => {
  try {
    const user = localStorage.getItem('user');
    return user ? JSON.parse(user) : null;
  } catch {
    return null;
  }
};

const View = ({ fleet, index }) => {
  const [showViewModel, setShowViewModel] = useState(false);
  const [showEditModel, setShowEditModel] = useState(false);
  const [showDeleteModel, setShowDeleteModel] = useState(false);
  const currentUser = getCurrentUserFromStorage();
  const [canCreateOrder, setCanCreateOrder] = useState(fleet.canCreateOrder ?? true);

  const canShowActions = checkPermission(
    [permissions.manage_masters, permissions.view_fleet_master_actions],
    currentUser
  );

  return (
    <Fragment>
      <tr
        key={fleet._id}
        className={`${index % 2 !== 0 && 'bg-gray-100'}`}
      >
        <TD>{index + 1}</TD>
        <TD>{fleet.fleetCode}</TD>
        <TD>{fleet.fleetName}</TD>
        <TD className="flex items-center gap-2">
          {fleet.agreedCPKM}
          </TD>

        {canShowActions && (
        <TD>
        <div className="flex items-center space-x-2">
          <button
            onClick={async () => {
              const newValue = !canCreateOrder;
              setCanCreateOrder(newValue);

              try {
                await updateDocumentByID('customer-fleet', fleet._id, {
                  canCreateOrder: newValue,
                });
                toast.success(`Order ${newValue ? 'Unlocked' : 'Locked'} successfully`);
              } catch (err) {
                setCanCreateOrder(!newValue);
                toast.error("Failed to update order lock status");
              }
            }}
            className={`relative inline-flex items-center h-6 rounded-full w-11 transition-colors duration-300 ${
              canCreateOrder ? 'bg-green-500' : 'bg-red-500'
            }`}
          >
            <span
              className={`inline-block w-4 h-4 transform bg-white rounded-full transition-transform duration-300 ${
                canCreateOrder ? 'translate-x-6' : 'translate-x-1'
              }`}
            />
          </button>
          <span className="text-sm font-medium">
            {canCreateOrder ? 'Unlocked' : 'Locked'}
          </span>
        </div>
        </TD>
)}

        <TD>
          {canShowActions ? (
            <div className="">
              <button
                onClick={() => setShowEditModel(true)}
                className="p-2 m-1  rounded-md bg-green-500 hover:bg-green-600 text-white"
              >
                <FaEdit />
              </button>
            </div>
          ) : (
            <p>----</p>
          )}
        </TD>
      </tr>

      {showViewModel && (
        <Edit
          data={fleet}
          desable={true}
          handleClick={() => setShowViewModel(false)}
        />
      )}
      {showEditModel && (
        <Edit
          data={fleet}
          handleClick={() => setShowEditModel(false)}
        />
      )}
    </Fragment>
  );
};

export default View;